import React from 'react';
import { Modal, Button } from '@weezevent/nacre';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import classes from './DeleteModal.module.scss';

export const DeleteModal = ({ open, title, description, onCancel, onSubmit, children, isSubmitting }) => {
    const { t } = useTranslation();
    const defaultDescription = t('common.deleteModal.warning');

    return (
        <Modal
            open={open}
            title={title}
            onClose={onCancel}
            submitButton={
                <Button primary as="button" onClick={onSubmit} className={classes.deleteButton} isLoading={isSubmitting}>
                    {t(`common.cta.delete`)}
                </Button>
            }
            cancelButton={
                <Button as="button" onClick={onCancel}>
                    {t(`common.cta.cancel`)}
                </Button>
            }
        >
            <div className={classes.description}>{description || defaultDescription}</div>
            {children}
        </Modal>
    );
};

DeleteModal.propTypes = {
    title: PropTypes.string.isRequired,
    description: PropTypes.string,
    onCancel: PropTypes.func,
    onSubmit: PropTypes.func,
    open: PropTypes.bool,
    children: PropTypes.node,
    isSubmitting: PropTypes.bool
};
